import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { BankOpsApi, PayableApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null
};

const PayableSlice = createSlice({
  name: 'Payable',
  initialState,
  reducers: {
    setPayableGrid(state, action) {
      state.list_data = action.payload;
    },

    setPayableViewGrid(state, action) {
      state.view_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Payable  View
export const getPayableListData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayableApi?.payableList,
      method: 'post',
      payload: data
    });
    console.log('✅ Payable List res rrrrr', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPayableGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPayableGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payable List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Ops View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Payable  View
export const getPayableViewData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${PayableApi?.payableView}/${data}`,
      method: 'get',
      payload: data
    });
    console.log('✅ Payable View res rrrrr', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPayableViewGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPayableViewGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payable View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Payable View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setPayableGrid, setPayableViewGrid } = PayableSlice.actions;
export default PayableSlice.reducer;
